import { detectAppMode } from './core/detect-app.js'

export async function bootstrap(): Promise<void> {
  const mode = detectAppMode()
  document.body.dataset.app = mode


  const metaDesc = document.querySelector('meta[name="description"]')

  if (mode === 'gestor') {
    document.title = 'Mi gestor · Chill Streaming'
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Panel de administración de Chill Streaming.')
    }
    const { initGestor } = await import('./gestor.js')
    initGestor()
  }
  else {
    document.title = 'Administrador de cuentas · Chill Streaming'
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Portal de autoservicio de clientes de Chill Streaming.')
    }
    const { initClientes } = await import('./clientes.js')
    initClientes()
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    bootstrap()
  })
}
else {
  bootstrap()
}
